"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pushOrReplaceChat = exports.replaceLatestWithHome = exports.extractChatIdFromLocation = void 0;
const u64 = __importStar(require("../utils/u64Functions"));
const extractChatIdFromLocation = () => {
    let path = document.location.pathname;
    if (path.length > 0 && path[0] == '/') {
        path = path.slice(1);
    }
    const parts = path.split('/');
    if (parts.length > 0 && parts[0].length > 0) {
        try {
            return u64.fromHex(parts[0]);
        }
        catch (_a) {
            return null;
        }
    }
    return null;
};
exports.extractChatIdFromLocation = extractChatIdFromLocation;
function replaceLatestWithHome() {
    if (!history)
        return;
    history.replaceState(null, "Home", "/");
}
exports.replaceLatestWithHome = replaceLatestWithHome;
function pushOrReplaceChat(chatId, replace) {
    if (!history)
        return;
    const hexId = u64.toHex(chatId);
    const method = replace ? "replaceState" : "pushState";
    history[method]({ chatId }, "", `/${hexId}`);
}
exports.pushOrReplaceChat = pushOrReplaceChat;
